<template>
    <button class="btn btn-outline-primary" type="button" ref="buttonElement" />
</template>

<script>

export default {
    name: 'PattanButton',

    created() {
        this.stateIndex = this.startState
    },
    
    data() {
        return {
            stateIndex: 0,
        }
    },

    methods: {
        advanceState() {
            this.stateIndex++
            if (this.stateIndex >= this.states.length) {
                this.stateIndex = 0
            }
            this.setState(this.states[this.stateIndex])
        },

        setState(state) {
            this.$refs.buttonElement.addEventListener('click', (event) => {
                state.onClick(event)
                this.advanceState()
            }, {once: true})
            this.$refs.buttonElement.style.color = state.color
            this.$refs.buttonElement.style.borderColor = state.color
            this.$refs.buttonElement.innerHTML = state.label
        },
    },

    mounted() {
        if (this.states && this.states[this.startState]) {
            this.setState(this.states[this.startState])
        }
    },

    props: {
        startState: {
            type: Number,
            default: 0,
        },
        states: {
            type: Array,
        },
    },
}

</script>

<style scoped>
.btn {
    background-color: transparent;
    height: 1.7em;
    line-height: 0.1em;
    width: 11.5em;
}

.btn:hover {
    background-color: transparent;
}

.btn:focus {
    background-color: transparent;
    outline: 1px solid darkblue;
}
</style>
